import React from 'react'

import BasicPage from '../components/Page/BasicPage'

import notfound320 from '../../../img/not-found-320.png'
import notfound600 from '../../../img/not-found-600.png'
import notfound1024 from '../../../img/not-found-1024.png'
import notfound1360 from '../../../img/not-found-1360.png'
import '../../scss/pages/_not-found.scss'

const NotFound = () => (
  <BasicPage className="not-found" title="Not Found" nonIndexable>
    <div className="not-found-hero">
      <img
        alt="Obi-Wan Kenobi, from the original Star Wars trilogy, performing a Jedi Mind Trick"
        className="not-found-hero__image"
        srcSet={`${notfound320} 320w, ${notfound600} 600w, ${notfound1024} 1024w, ${notfound1360} 1360w`}
      />
      <h1 className="not-found-hero__title">
        This isn&apos;t the web page you&apos;re looking for. <span>This is a 404.</span>
      </h1>
    </div>
  </BasicPage>
)

export default NotFound
